export const settings = {
  'settings.title': 'الإعدادات',
  'settings.subtitle': 'ملف المدرسة والسنوات والصفوف والمستخدمون والميزات',
  'settings.tabs': 'أقسام الإعدادات',
  'settings.tab.profile': 'ملف المدرسة',
  'settings.tab.years': 'السنوات الدراسية',
  'settings.tab.grades': 'المراحل والصفوف',
  'settings.tab.classes': 'الشُّعب',
  'settings.tab.cashAccounts': 'الصناديق والحسابات',
  'settings.tab.members': 'المستخدمون',
  'settings.tab.features': 'ميزات المدرسة',
  'settings.tab.audit': 'سجل التدقيق',
  'settings.profile.identity': 'هوية المدرسة',
  'settings.profile.name': 'اسم المدرسة بالعربية',
  'settings.profile.nameEn': 'اسم المدرسة بالإنجليزية',
  'settings.profile.logoUrl': 'رابط الشعار',
  'settings.profile.logoHint': 'رابط صورة يبدأ بـ https، يظهر في القائمة والوصولات',
  'settings.profile.logoInvalid': 'أدخل رابطاً صحيحاً يبدأ بـ https://',
  'settings.profile.logoPreview': 'معاينة الشعار',
  'settings.profile.color': 'لون المدرسة',
  'settings.profile.colorHint': 'بصيغة ‎#RRGGBB، يُستخدم لعلامة المدرسة',
  'settings.profile.colorInvalid': 'اكتب اللون بصيغة ‎#1A2B3C',
  'settings.profile.colorClear': 'بدون لون مخصص',
  'settings.profile.rules': 'قواعد الحساب',
  'settings.profile.roundingUnit': 'وحدة التقريب',
  'settings.profile.roundingHint': 'تُقرَّب الأقساط وأقساط السلف إلى هذه الوحدة، والباقي على القسط الأخير',
  'settings.profile.divisor': 'قاسم يوم الغياب',
  'settings.profile.divisorHint': 'خصم يوم الغياب = الراتب الأساسي ÷ هذا الرقم (بين ٢٠ و٣١)',
  'settings.profile.divisorInvalid': 'أدخل رقماً بين ٢٠ و٣١',
  'settings.profile.studentLogin': 'دخول الطلاب إلى التطبيق',
  'settings.profile.studentLoginHint': 'يحصل الطلاب على حساب خاص من هذا الصف فما فوق',
  'settings.profile.studentLoginNone': 'لا حسابات للطلاب',
  'settings.profile.fromGrade': 'من {grade}',
  'settings.profile.fixed': 'بيانات ثابتة',
  'settings.profile.fixedHint': 'تُحدَّد عند إنشاء المدرسة؛ لتغييرها تواصل مع إدارة المنصّة.',
  'settings.profile.country': 'الدولة',
  'settings.profile.currency': 'العملة',
  'settings.profile.locale': 'تنسيق الأرقام والتواريخ',
  'settings.profile.timeZone': 'المنطقة الزمنية',
  'settings.profile.status': 'حالة الاشتراك',
  'settings.profile.saved': 'حُفظ ملف المدرسة',
  'settings.profile.noChanges': 'لا تغييرات للحفظ',
  'settings.status.TRIAL': 'تجريبي',
  'settings.status.ACTIVE': 'فعّال',
  'settings.status.READ_ONLY': 'قراءة فقط',
  'settings.status.SUSPENDED': 'موقوف',
  'settings.years.title': 'السنوات الدراسية',
  'settings.years.add': 'سنة دراسية جديدة',
  'settings.years.name': 'اسم السنة',
  'settings.years.namePlaceholder': '2027–2028',
  'settings.years.start': 'تاريخ البداية',
  'settings.years.end': 'تاريخ النهاية',
  'settings.years.endBeforeStart': 'يجب أن تكون النهاية بعد البداية',
  'settings.years.makeCurrent': 'اجعلها السنة الحالية',
  'settings.years.makeCurrentHint': 'الرسوم والمدفوعات والشُّعب الجديدة تُسجَّل على السنة الحالية',
  'settings.years.current': 'السنة الحالية',
  'settings.years.setCurrent': 'تعيين كسنة حالية',
  'settings.years.setCurrentTitle': 'تعيين {name} سنةً حالية؟',
  'settings.years.setCurrentBody': 'من الآن تُسجَّل الرسوم والمدفوعات والتسجيلات الجديدة على هذه السنة. السنة السابقة تبقى محفوظة للاطلاع.',
  'settings.years.created': 'أُضيفت السنة الدراسية',
  'settings.years.currentSet': 'تغيّرت السنة الحالية',
  'settings.years.empty': 'لا سنوات دراسية بعد',
  'settings.years.period': 'الفترة',
  'settings.grades.title': 'المراحل والصفوف',
  'settings.grades.hint': 'يُعرَّف كل صف برقمه (١–١٢) في كل الحسابات؛ الاسم للعرض فقط ويمكن تعديله.',
  'settings.grades.number': 'الرقم',
  'settings.grades.stage': 'المرحلة',
  'settings.grades.nameAr': 'الاسم بالعربية',
  'settings.grades.nameEn': 'الاسم بالإنجليزية',
  'settings.grades.nationalExam': 'امتحان وزاري',
  'settings.grades.hidden': 'مخفي',
  'settings.grades.visible': 'ظاهر',
  'settings.grades.hide': 'إخفاء',
  'settings.grades.show': 'إظهار',
  'settings.grades.hiddenHint': 'الصف المخفي لا يظهر في القوائم (للصفوف التي لا تدرّسها المدرسة)',
  'settings.grades.edit': 'تعديل الصف',
  'settings.grades.add': 'إضافة صف',
  'settings.grades.addHint': 'للروضة استخدم الأرقام ٠ و‎-1 و‎-2',
  'settings.grades.saved': 'حُفظ الصف',
  'settings.grades.created': 'أُضيف الصف',
  'settings.grades.numberInvalid': 'أدخل رقماً بين ‎-3 و١٢',
  'settings.classes.title': 'الشُّعب',
  'settings.classes.year': 'السنة الدراسية',
  'settings.classes.add': 'شعبة جديدة',
  'settings.classes.grade': 'الصف',
  'settings.classes.name': 'اسم الشعبة',
  'settings.classes.namePlaceholder': 'أ',
  'settings.classes.stream': 'الفرع',
  'settings.classes.streamHint': 'للصفوف ١٠–١٢ فقط، مثل: العلمي · الأحيائي',
  'settings.classes.streamNotAllowed': 'الفروع للصفوف ١٠–١٢ فقط',
  'settings.classes.students': '{n}',
  'settings.classes.created': 'أُضيفت الشعبة',
  'settings.classes.empty': 'لا شُعب في هذه السنة',
  'settings.classes.emptyBody': 'أنشئ الشُّعب قبل تسجيل الطلاب.',
  'settings.classes.noYear': 'حدّد سنة دراسية حالية أولاً.',
  'settings.cash.title': 'الصناديق والحسابات',
  'settings.cash.hint': 'النقد يُقبض في صندوق نقدي؛ البطاقة والتحويل والصك في حساب مصرفي؛ المحفظة في حساب محفظة أو المصرف.',
  'settings.cash.add': 'حساب جديد',
  'settings.cash.name': 'اسم الحساب',
  'settings.cash.namePlaceholder': 'صندوق الاستقبال',
  'settings.cash.type': 'نوع الحساب',
  'settings.cash.default': 'الافتراضي',
  'settings.cash.defaultHint': 'يُستخدم تلقائياً عند عدم اختيار حساب',
  'settings.cash.created': 'أُضيف الحساب',
  'settings.cash.empty': 'لا حسابات بعد',
  'settings.members.title': 'المستخدمون',
  'settings.members.hint': 'موظفو المكتب والمدرّسون والموظفون الذين لهم حساب في المدرسة. أولياء الأمور يُضافون مع الطلاب.',
  'settings.members.add': 'إضافة مستخدم',
  'settings.members.name': 'الاسم الكامل',
  'settings.members.phone': 'رقم الهاتف',
  'settings.members.role': 'الدور',
  'settings.members.since': 'منذ',
  'settings.members.you': 'أنت',
  'settings.members.added': 'أُضيف {name}',
  'settings.members.addedHint': 'يدخل لأول مرة من «أول مرة أو نسيت كلمة المرور؟» في صفحة الدخول برمز يصل إلى هاتفه.',
  'settings.members.ownerOnly': 'المالك وحده يضيف المديرين أو يغيّر حالتهم',
  'settings.members.status.ACTIVE': 'فعّال',
  'settings.members.status.SUSPENDED': 'موقوف',
  'settings.members.status.REVOKED': 'مُلغى',
  'settings.members.suspend': 'إيقاف مؤقت',
  'settings.members.revoke': 'إلغاء الوصول',
  'settings.members.reactivate': 'إعادة التفعيل',
  'settings.members.suspendTitle': 'إيقاف {name} مؤقتاً؟',
  'settings.members.suspendBody': 'يُسجَّل خروجه من هذه المدرسة فوراً ولا يستطيع الدخول حتى تعيد تفعيله.',
  'settings.members.revokeTitle': 'إلغاء وصول {name}؟',
  'settings.members.revokeBody': 'يُسجَّل خروجه ويُلغى دوره في هذه المدرسة. سجلّاته السابقة تبقى في سجل التدقيق.',
  'settings.members.reactivateTitle': 'إعادة تفعيل {name}؟',
  'settings.members.reactivateBody': 'يستطيع الدخول من جديد بدوره الحالي.',
  'settings.members.statusChanged': 'تغيّرت حالة {name}',
  'settings.members.filter': 'تصفية حسب الدور',
  'settings.members.filterOffice': 'الإدارة والمحاسبة',
  'settings.members.filterStaff': 'المدرّسون والموظفون',
  'settings.members.empty': 'لا مستخدمين بهذا الدور',
  'settings.features.title': 'ميزات المدرسة',
  'settings.features.hint': 'تُفعَّل الميزات أو توقف لكل مدرسة وتُطبَّق في الخادم. إيقاف ميزة يخفيها ويحتفظ ببياناتها؛ وتعود كما هي عند التفعيل.',
  'settings.features.alwaysOn': 'ملف المدرسة والطلاب وأولياء الأمور والمستخدمون والإعلانات وسجل التدقيق تعمل دائماً.',
  'settings.features.by.platform': 'تتحكم بها المنصّة',
  'settings.features.by.school': 'يتحكم بها مدير المدرسة',
  'settings.features.platformLocked': 'تُفعَّل من إدارة المنصّة ضمن الاشتراك',
  'settings.features.needs': 'تحتاج: {list}',
  'settings.features.needsOff': 'فعّل أولاً: {list}',
  'settings.features.on': 'مفعّلة',
  'settings.features.off': 'متوقفة',
  'settings.features.enabled': 'فُعّلت «{name}»',
  'settings.features.disabled': 'أُوقفت «{name}»',
  'settings.features.cascadeTitle': 'إيقاف «{name}»؟',
  'settings.features.cascadeBody': 'هذه الميزات تعتمد عليها وستُوقف معها:',
  'settings.features.cascadeKeep': 'البيانات تبقى محفوظة، وتعود عند إعادة التفعيل.',
  'settings.features.cascadeConfirm': 'إيقافها جميعاً',
  'settings.features.openAdvances': 'لا يمكن إيقاف الرواتب: هناك {n} مفتوحة يجب أن تُسدَّد أو تُشطب أولاً.',
  'settings.feature.fees': 'الرسوم والمدفوعات',
  'settings.feature.fees.desc': 'شاشات الرسوم والوصولات وإغلاق الصندوق، وعرض الرسوم لولي الأمر وتذكيرات الأقساط',
  'settings.feature.payroll': 'الرواتب',
  'settings.feature.payroll.desc': 'ملفات الموظفين والعقود والمسيّر الشهري وقسائم الرواتب',
  'settings.feature.advances': 'السُّلف',
  'settings.feature.advances.desc': 'طلبات السلف وموافقتها وصرفها وخصمها من الراتب ضمن الحد القانوني',
  'settings.feature.staffAttendance': 'دوام الموظفين',
  'settings.feature.staffAttendance.desc': 'تسجيل الدوام والإجازات، ويغذّي استقطاع الغياب في الرواتب',
  'settings.feature.timetable': 'الجدول الدراسي',
  'settings.feature.timetable.desc': 'جدول الحصص لكل شعبة في التطبيق',
  'settings.feature.examsGrades': 'الامتحانات والدرجات',
  'settings.feature.examsGrades.desc': 'إدخال الدرجات وظهورها لأولياء الأمور والطلاب',
  'settings.feature.reportCards': 'الشهادات المدرسية',
  'settings.feature.reportCards.desc': 'شهادات PDF بنموذج الدولة',
  'settings.feature.homework': 'الواجبات',
  'settings.feature.homework.desc': 'تبويب الواجبات للمدرّسين والطلاب وأولياء الأمور',
  'settings.feature.studentAttendance': 'حضور الطلاب',
  'settings.feature.studentAttendance.desc': 'تسجيل الحضور من التطبيق وتنبيه ولي الأمر بالغياب',
  'settings.feature.studentAccounts': 'حسابات الطلاب',
  'settings.feature.studentAccounts.desc': 'دخول الطلاب إلى التطبيق من الصف المحدد في ملف المدرسة',
  'settings.feature.homeworkSubmissions': 'تسليم الواجبات من الطلاب',
  'settings.feature.homeworkSubmissions.desc': 'رفع ملفات الحل من حساب الطالب',
  'settings.feature.studentsSeeFees': 'الطلاب يرون الرسوم',
  'settings.feature.studentsSeeFees.desc': 'إظهار رصيد الرسوم في حساب الطالب (مغلق افتراضياً)',
  'settings.feature.teacherNotes': 'ملاحظات المعلّمين',
  'settings.feature.teacherNotes.desc': 'يكتب المعلّم ملاحظة عن الطالب (إشادة، دراسية، سلوكية) فتصل لولي الأمر في التطبيق',
  'settings.feature.messaging': 'رسائل SMS وواتساب',
  'settings.feature.messaging.desc': 'بديل عند فشل الإشعارات · بتكلفة على كل رسالة',
  'settings.audit.title': 'سجل التدقيق',
  'settings.audit.hint': 'كل تغيير في المدرسة: من، ومتى، وماذا تغيّر. لا يُحذف شيء منه.',
  'settings.audit.entity': 'السجل',
  'settings.audit.allEntities': 'كل السجلات',
  'settings.audit.when': 'الوقت',
  'settings.audit.who': 'بواسطة',
  'settings.audit.action': 'العملية',
  'settings.audit.system': 'النظام',
  'settings.audit.showChanges': 'عرض التغييرات',
  'settings.audit.field': 'الحقل',
  'settings.audit.before': 'قبل',
  'settings.audit.after': 'بعد',
  'settings.audit.noDetails': 'لا تفاصيل إضافية',
  'settings.audit.empty': 'لا عمليات مسجّلة',
  'settings.audit.end': 'نهاية السجل',
  'settings.audit.entity.payment': 'المدفوعات',
  'settings.audit.entity.student': 'الطلاب',
  'settings.audit.entity.student_charge': 'رسوم الطلاب',
  'settings.audit.entity.discount': 'الخصومات',
  'settings.audit.entity.fee_item': 'بنود الرسوم',
  'settings.audit.entity.cash_closing': 'إغلاق الصندوق',
  'settings.audit.entity.cash_account': 'الصناديق والحسابات',
  'settings.audit.entity.advance': 'السُّلف',
  'settings.audit.entity.payroll_run': 'مسيّرات الرواتب',
  'settings.audit.entity.payslip': 'قسائم الرواتب',
  'settings.audit.entity.staff': 'الموظفون',
  'settings.audit.entity.membership': 'المستخدمون',
  'settings.audit.entity.school': 'ملف المدرسة',
  'settings.audit.entity.school_feature': 'ميزات المدرسة',
  'settings.audit.entity.academic_year': 'السنوات الدراسية',
  'settings.audit.entity.grade_level': 'الصفوف',
  'settings.audit.entity.class': 'الشُّعب',
  'settings.audit.entity.student_note': 'ملاحظات المعلّمين',
  'settings.audit.action.payment.create': 'تسجيل وصل',
  'settings.audit.action.payment.clear': 'تسوية دفعة',
  'settings.audit.action.payment.bounce': 'دفعة مرتجعة',
  'settings.audit.action.payment.reverse': 'قيد عكسي لدفعة',
  'settings.audit.action.student.create': 'تسجيل طالب',
  'settings.audit.action.student.update': 'تعديل بيانات طالب',
  'settings.audit.action.student.transfer': 'نقل طالب',
  'settings.audit.action.student.withdraw': 'انسحاب طالب',
  'settings.audit.action.student.login': 'حساب دخول للطالب',
  'settings.audit.action.note.create': 'ملاحظة عن طالب',
  'settings.audit.action.note.hide': 'إخفاء ملاحظة',
  'settings.audit.action.students.import': 'استيراد طلاب',
  'settings.audit.action.installments.set': 'خطة أقساط',
  'settings.audit.action.charge.cancel': 'إلغاء رسم',
  'settings.audit.action.charge.opening_balance': 'رصيد افتتاحي',
  'settings.audit.action.discount.request': 'طلب خصم',
  'settings.audit.action.discount.approve': 'موافقة على خصم',
  'settings.audit.action.discount.reject': 'رفض خصم',
  'settings.audit.action.fee_item.create': 'بند رسوم جديد',
  'settings.audit.action.fee_item.active': 'تغيير حالة بند رسوم',
  'settings.audit.action.fee_item.apply': 'تطبيق بند رسوم',
  'settings.audit.action.cash.close': 'إغلاق صندوق',
  'settings.audit.action.cash_account.create': 'حساب جديد',
  'settings.audit.action.advance.request': 'طلب سلفة',
  'settings.audit.action.advance.approve': 'موافقة على سلفة',
  'settings.audit.action.advance.reject': 'رفض سلفة',
  'settings.audit.action.advance.cancel': 'إلغاء سلفة',
  'settings.audit.action.advance.payout': 'صرف سلفة',
  'settings.audit.action.advance.repay_cash': 'سداد سلفة نقداً',
  'settings.audit.action.advance.skip': 'تأجيل قسط سلفة',
  'settings.audit.action.advance.write_off': 'شطب سلفة',
  'settings.audit.action.payroll.create': 'إعداد مسيّر رواتب',
  'settings.audit.action.payroll.approve': 'اعتماد مسيّر رواتب',
  'settings.audit.action.payroll.delete': 'حذف مسودة مسيّر',
  'settings.audit.action.payroll.pay': 'دفع راتب',
  'settings.audit.action.staff.create': 'إضافة موظف',
  'settings.audit.action.staff.update': 'تعديل بيانات موظف',
  'settings.audit.action.staff.contract': 'عقد جديد',
  'settings.audit.action.staff.allowance.add': 'إضافة مخصص',
  'settings.audit.action.staff.allowance.end': 'إنهاء مخصص',
  'settings.audit.action.staff.deduction.add': 'غياب أو جزاء',
  'settings.audit.action.staff.deduction.remove': 'حذف غياب أو جزاء',
  'settings.audit.action.staff.leave': 'ترك العمل',
  'settings.audit.action.member.add': 'إضافة مستخدم',
  'settings.audit.action.member.status': 'تغيير وصول مستخدم',
  'settings.audit.action.school.create': 'إنشاء المدرسة',
  'settings.audit.action.school.status': 'تغيير حالة الاشتراك',
  'settings.audit.action.school.update': 'تعديل ملف المدرسة',
  'settings.audit.action.feature.enable': 'تفعيل ميزة',
  'settings.audit.action.feature.disable': 'إيقاف ميزة',
  'settings.audit.action.year.create': 'سنة دراسية جديدة',
  'settings.audit.action.year.set_current': 'تغيير السنة الحالية',
  'settings.audit.action.grade.create': 'إضافة صف',
  'settings.audit.action.grade.update': 'تعديل صف',
  'settings.audit.action.class.create': 'شعبة جديدة',
  'settings.features.platformNote': 'الميزات التي تتحكم بها المنصّة جزء من الاشتراك؛ لتغييرها تواصل مع إدارة المنصّة.',
  'settings.tab.calendar': 'التقويم',
  'settings.calendar.title': 'أيام التقويم',
  'settings.calendar.hint': 'أيام العطل لا يُسجَّل فيها حضور. أيام الامتحانات وأيام العطلة الأسبوعية الإضافية للعلم وتظهر في تقويم الطالب.',
  'settings.calendar.add': 'إضافة يوم',
  'settings.calendar.date': 'التاريخ',
  'settings.calendar.type': 'النوع',
  'settings.calendar.note': 'ملاحظة',
  'settings.calendar.notePlaceholder': 'مثلاً: عيد الأضحى',
  'settings.calendar.type.HOLIDAY': 'عطلة',
  'settings.calendar.type.EXAM': 'امتحانات',
  'settings.calendar.type.WEEKEND': 'عطلة أسبوعية',
  'settings.calendar.empty': 'لا أيام مسجّلة في هذه الفترة',
  'settings.calendar.added': 'أُضيف {date}',
  'settings.calendar.removed': 'حُذف اليوم من التقويم',
  'settings.calendar.remove': 'حذف {date}',
} as const;
